import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { StreetAdditionalInput } from './StreetAdditionalInput';

export function StreetAdditionalField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues> {...props} Input={StreetAdditionalInput} />
  );
}
